import {deserialize} from 'cerialize';

export class KickaroundPermissions {
  @deserialize
  hasGameHostControls: boolean;
}
